import { render, staticRenderFns } from "./VcitaChip.vue?vue&type=template&id=0a0328c2&scoped=true"
import script from "./VcitaChip.vue?vue&type=script&lang=js"
export * from "./VcitaChip.vue?vue&type=script&lang=js"
import style0 from "./VcitaChip.vue?vue&type=style&index=0&id=0a0328c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0328c2",
  null
  
)

export default component.exports